import dayjs                          from "dayjs";
import fromNow                        from "dayjs/plugin/relativeTime";
import utc                            from "dayjs/plugin/utc";
import React, { useEffect, useState } from "react";

import { storeCTEvent }        from "_analytics/index";
import Toast                   from "_common/toast";
import { getChannelAnalytics } from "_services/api/creator-dashboard";

import Presentation from "./presentation";

dayjs.extend ( fromNow );
dayjs.extend ( utc );

const initialAnalyticsState = {
	totalFollowers    : null,
	diffFollowers     : null,
	totalViews        : null,
	diffViews         : null,
	totalWatchMinutes : null,
	diffWatchMinutes  : null,
	totalRevenue      : null,
	diffRevenue       : null
};

const getStartDate = daysToSub => {
	const now       = dayjs.utc ();
	const startDate = now.subtract ( daysToSub, "day" ).format ( "YYYY-MM-DD HH:mm:ss" );

	return startDate;
};

const getEndDate = daysToSub => {
	const now     = dayjs.utc ();
	const endDate = now.subtract ( 2 * daysToSub, "day" ).format ( "YYYY-MM-DD HH:mm:ss" );

	return endDate;
};

const fetchAnalytics = async ( type, startDate, endDate ) => {
	try {
		const updatedData = await getChannelAnalytics ( type, startDate, endDate );

		return updatedData;

	} catch ( err ) {
		Toast.error ( err.displayMsg );
	}
};

const component = ( { isMobile, isMigratingData } ) => {

	const [ analytics, setAnalytics ] = useState ( initialAnalyticsState );

	useEffect ( () => {
		getData ();
	}, [] );

	const getData = async () => {
		if ( isMigratingData )
			return;
		const data = await fetchAnalytics ();

		if ( !data )
			return;
		setAnalytics ( data );
	};

	const updateData = async val => {
		if ( isMigratingData )
			return;
		let type      = Number ( val );
		let startDate = 0, endDate = 0;

		const ctOptions = {
			eventProperty : "time_filter",
			value         : isNaN ( type ) ? "All time" : type === 7 ? "last 7" : "last 30"
		};

		storeCTEvent ( "creator_dashboard_navigation", ctOptions );

		if ( isNaN ( type ) ) {
			let response = await fetchAnalytics ( val, startDate, endDate );

			if ( response ) {
				setAnalytics ( response );
			}
		} else {
			startDate = getStartDate ( type );
			endDate   = getEndDate ( type );

			let response = await fetchAnalytics ( val, startDate, endDate );

			if ( response ) {
				setAnalytics ( response );
			}
		}
	};
	const filterCategories = {
		7   : "Last 7 Days",
		30  : "Last 30 days",
		all : "All Time"
	};

	return (
		<Presentation
			analytics         = { analytics }
			filterCategories  = { filterCategories }
			isMigratingData   = { isMigratingData }
			isMobile          = { isMobile }
			updateData        = { updateData }
		/>
	);
};

export default component;

